import { render, staticRenderFns } from "./JudgementTemplatePreviewModal.vue?vue&type=template&id=2a0cd630&scoped=true&lang=pug"
import script from "./JudgementTemplatePreviewModal.vue?vue&type=script&lang=ts"
export * from "./JudgementTemplatePreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0cd630",
  null
  
)

export default component.exports